

/// <reference path="Product.ts" />

// Generated class LicenseProduct_ManagedObject

class LicenseProduct_ManagedObject extends Product
{
}
